import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import useAgencyPortal from '@hooks/useAgencyPortal'
import { generateUrls } from '@hooks/useAgency'

import { confirmDelete } from '@functions/entity'

import type { AgencyPortalModel } from '@models/types'

const PortalAgencyListItem = (props: { agencyPortal: AgencyPortalModel}) => {
  const { agencyPortal: initAgencyPortal } = props

  const {
    callbacks: {
      createOrEditAgencyPortal,
      deleteAgencyPortal: deleteFn,
    },
    agency,
  } = useAgencyPortal(initAgencyPortal)

  // @ts-expect-error TS2339
  const { address_region, title: agencyTitle } = agency

  // @ts-expect-error TS2339
  const { editAgencyUrl } = generateUrls({ id: agency.id })

  const deleteAgencyPortalPayload = {
    callbacks: { deleteFn },
    strings: {
      entityName: 'Agency',
      deleteString: 'remove',
    },
  }

  return (
    <DashboardModuleListItem
      secondaryText={address_region}
      title={agencyTitle}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          // @ts-expect-error TS2554
          onClick={() => createOrEditAgencyPortal()}
          type="edit"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(deleteAgencyPortalPayload)}
          type="delete"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editAgencyUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default PortalAgencyListItem
